import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "7.5",
      r: "2.5",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9.99984",
      cy: "10.0001",
      r: "8.33333",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.9745 16.6667C14.8419 14.2571 14.1042 12.5 10.0002 12.5C5.89625 12.5 5.1585 14.2571 5.02588 16.6667",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }